import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { loginOAuth, signEula } from "authentication/AuthenticationService";
import { useAuth } from "authentication/AuthProvider";
import EulaDialog from "authentication/EulaDialog";

import { replaceWithFrom } from "utils/RouterUtils";

const OAuth2LoginRedirect: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { principal, refreshTokens, updateTokens, removeTokens } = useAuth();

	const [eulaDialog, setEulaDialog] = useState(false);

	useEffect(() => {
		if (!principal) {
			return;
		}

		if (principal.isAllowedAccess()) {
			replaceWithFrom(navigate, location);
		}

		if (!principal.signedEula) {
			setEulaDialog(true);
		}
	}, [principal]);

	useEffect(() => {
		const path = location.pathname;
		const provider = path.substring(path.lastIndexOf("/") + 1);
		const code = new URLSearchParams(location.search).get("code");

		if (code !== null) {
			loginOAuth(provider, code)
				.then(updateTokens)
				.catch(() => replaceWithFrom(navigate));
		} else {
			replaceWithFrom(navigate);
		}
	}, []);

	return (
		<>
			{eulaDialog && (
				<EulaDialog
					onClose={() => {
						removeTokens();
						navigate("/login", { replace: true });
					}}
					onAccept={() =>
						signEula().then(() =>
							refreshTokens(principal?.organisationId)
						)
					}
				/>
			)}
		</>
	);
};

export default OAuth2LoginRedirect;
